export const TRIPO_MODEL_VERSIONS = [ 'v2.5-20250123', 'v3.0', 'v3.1' ];
export const TRIPO_TEXTURE_QUALITIES = [ 'standard', 'detailed' ];
export const TRIPO_TEXTURE_ALIGNMENTS = [ 'original_image', 'geometry' ];
export const TRIPO_GEOMETRY_QUALITIES = [ 'standard', 'detailed' ];
export const TRIPO_ORIENTATIONS = [ 'default', 'align_image' ];
export const TRIPO_FACE_LIMIT_MIN = 500;
export const TRIPO_FACE_LIMIT_MAX = 500000;
export const TRIPO_FACE_LIMIT_MIN_LOWPOLY = 1000;
export const TRIPO_FACE_LIMIT_MAX_LOWPOLY = 20000;

export const TRIPO_DEFAULTS = {
  modelVersion: 'v2.5-20250123',
  faceLimit: '',
  texture: true,
  pbr: true,
  textureQuality: 'standard',
  textureAlignment: 'original_image',
  geometryQuality: 'standard',
  autoSize: false,
  orientation: 'default',
  smartLowPoly: false,
  compress: false,
  generateParts: false,
  modelSeed: '',
  textureSeed: '',
  style: '',
};

export const tripoFaceLimitRange = smartLowPoly => (smartLowPoly
  ? { min: TRIPO_FACE_LIMIT_MIN_LOWPOLY, max: TRIPO_FACE_LIMIT_MAX_LOWPOLY }
  : { min: TRIPO_FACE_LIMIT_MIN, max: TRIPO_FACE_LIMIT_MAX });

const isSet = value => value !== '' && value !== null && value !== undefined;

export const buildTripoProperties = settings => {
  const {
    modelVersion,
    faceLimit,
    texture,
    pbr,
    textureQuality,
    textureAlignment,
    geometryQuality,
    autoSize,
    orientation,
    smartLowPoly,
    compress,
    generateParts,
    modelSeed,
    textureSeed,
    style,
  } = settings;

  const properties = {
    modelVersion,
    texture: pbr ? true : texture,
    pbr,
    textureQuality,
    textureAlignment,
    geometryQuality,
    autoSize,
    orientation,
    smartLowPoly,
    compress,
    generateParts,
  };

  if (isSet(faceLimit)) {
    properties.faceLimit = Number(faceLimit);
  }
  if (isSet(modelSeed)) {
    properties.modelSeed = Number(modelSeed);
  }
  if (isSet(textureSeed)) {
    properties.textureSeed = Number(textureSeed);
  }
  if (style) {
    properties.style = style;
  }

  return properties;
};

export const validateTripoSettings = settings => {
  const errors = {};
  const {
    modelVersion,
    faceLimit,
    textureQuality,
    textureAlignment,
    geometryQuality,
    orientation,
    smartLowPoly,
    modelSeed,
    textureSeed,
  } = settings;

  if (!TRIPO_MODEL_VERSIONS.includes(modelVersion)) {
    errors.modelVersion = 'Invalid model version.';
  }
  if (!TRIPO_TEXTURE_QUALITIES.includes(textureQuality)) {
    errors.textureQuality = 'Invalid texture quality.';
  }
  if (!TRIPO_TEXTURE_ALIGNMENTS.includes(textureAlignment)) {
    errors.textureAlignment = 'Invalid texture alignment.';
  }
  if (!TRIPO_GEOMETRY_QUALITIES.includes(geometryQuality)) {
    errors.geometryQuality = 'Invalid geometry quality.';
  }
  if (!TRIPO_ORIENTATIONS.includes(orientation)) {
    errors.orientation = 'Invalid orientation.';
  }

  if (isSet(faceLimit)) {
    const numericFaceLimit = Number(faceLimit);
    const { min, max } = tripoFaceLimitRange(smartLowPoly);
    if (!Number.isFinite(numericFaceLimit) || numericFaceLimit < min || numericFaceLimit > max) {
      errors.faceLimit = `Face limit must be between ${min} and ${max}.`;
    }
  }

  if (isSet(modelSeed) && !Number.isInteger(Number(modelSeed))) {
    errors.modelSeed = 'Model seed must be an integer.';
  }
  if (isSet(textureSeed) && !Number.isInteger(Number(textureSeed))) {
    errors.textureSeed = 'Texture seed must be an integer.';
  }

  return { valid: Object.keys(errors).length === 0, errors };
};
